import script from "./StatTile.vue?vue&type=script&setup=true&lang=js"
export * from "./StatTile.vue?vue&type=script&setup=true&lang=js"

import "./StatTile.vue?vue&type=style&index=0&id=14d91aa0&lang=scss"

const __exports__ = script;

export default __exports__